import { set, isEmpty } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  clearItemSku,
  showAddItemSkuModal,
  hideAddItemSkuModal
} from '../../../actions/components/item-sku-lookup';
import { fetchInventorySkuBySku } from '../../../sagas/routines';

const initialState = {
  itemSku: null,
  fetching: false,
  fetched: false,
  fetchingError: null,
  showAddItemSkuModal: false
};

const clearItemSkuHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    itemSku: null,
    fetched: false,
    fetchingError: null
  })
});

const showAddItemSkuModalHandler = action => ({
  [action.toString()]: set('showAddItemSkuModal', true)
});

const hideAddItemSkuModalHandler = action => ({
  [action.toString()]: set('showAddItemSkuModal', false)
});

const fetchInventorySkuBySkuHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    fetching: true,
    fetched: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    itemSku: response,
    showAddItemSkuModal: isEmpty(response)
  }),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export default createReducer(initialState, {
  ...clearItemSkuHandler(clearItemSku),
  ...showAddItemSkuModalHandler(showAddItemSkuModal),
  ...hideAddItemSkuModalHandler(hideAddItemSkuModal),
  ...fetchInventorySkuBySkuHandler(fetchInventorySkuBySku)
});
